import React, { useState, useRef } from "react"
import Components from "../index"
import IconV2 from "../icon-v2"
import { blokType } from "../../types"
import { Swiper, SwiperSlide } from "swiper/react"
import {
  StyledCarousel,
  StyledModalCarousel,
  StyledButton,
} from "./partials"
import { StyledModalClose } from "../s22_modal/partials"

export interface WeekInLifeProps {
  blok: blokType[]
}

export const S22WeekInLife: React.FC<WeekInLifeProps> = ({ blok }) => {
  const [currentModal, setCurrentModal] = useState(0)
  const [currentCard, setCurrentCard] = useState(0)

  const swiperRefModal = useRef()
  const swiperRefCard = useRef()

  const [idx, setIdx] = React.useState(0)
  const [showModal, setShowModal] = React.useState(false)

  function handleCurrentModal(snapIndex) {
    setCurrentModal(snapIndex)
  }

  if (typeof window !== "undefined"){
    if (showModal){
      document.body.classList.add("g--no-scroll-v2")
    }
    else{
      document.body.classList.remove("g--no-scroll-v2")
    }
  }

  function handleShowModal(id, show) {
    setIdx(id)
    setShowModal(show)
  }

  return (
    <>
      {blok.days && blok.days.length > 0 && (
        <>
          {showModal && (
            <>
              <StyledModalCarousel visible={showModal} fullscreen={true}>
                <StyledModalClose onClick={() => setShowModal(false)}>
                  <IconV2 icon="times" size="18" iconType="fal" />
                </StyledModalClose>
                <Swiper
                  ref={swiperRefModal}
                  onSlideChange={(swiper) =>
                    handleCurrentModal(swiper?.snapIndex)
                  }
                  spaceBetween={0}
                  slidesPerView={1}
                  slidesPerGroup={+1}
                  centeredSlides={true}
                  initialSlide={idx}
                  loop={false}
                  allowTouchMove={false}
                >
                  {blok.days.length > 0 &&
                    blok.days.map(
                      (content: { modal: { _uid: string } }) =>
                        content.modal.length > 0 && (
                          <SwiperSlide key={content.modal[0]._uid}>
                            {React.createElement(
                              Components(content.modal[0].component),
                              {
                                blok: content.modal[0],
                                visible: showModal,
                                noOfCards: blok.days.length,
                                onClick: () => setShowModal(!showModal),
                                reference: content.modal[0].reference,
                                nextModal: () => swiperRefModal.current.swiper.slideNext(),
                                prevModal: () => swiperRefModal.current.swiper.slidePrev(),
                                disbableNext: swiperRefModal.current !== undefined && swiperRefModal.current.swiper && swiperRefModal.current.swiper.snapIndex + 1 === swiperRefModal.current.swiper.snapGrid.length,
                                disbablePrev: currentModal === 0,
                              }
                            )}
                          </SwiperSlide>
                        )
                    )}
                </Swiper>
              </StyledModalCarousel>
            </>
          )}
          <StyledCarousel fullscreen={false}>
            <Swiper
              ref={swiperRefCard}
              spaceBetween={16}
              slidesPerView={blok.slides_per_view_mobile}
              slidesPerGroup={+blok.slides_per_view_mobile}
              centeredSlides={false}
              loop={false}
              onSlideChange={(swiper) => setCurrentCard(swiper?.snapIndex)}
              breakpoints={{
                "1264": {
                  slidesPerView: blok.slides_per_view_wide,
                  slidesPerGroup: blok.slides_per_view_wide,
                },
                "1024": {
                  slidesPerView: blok.slides_per_view_desktop,
                  slidesPerGroup: blok.slides_per_view_desktop,
                },
                "768": {
                  slidesPerView: blok.slides_per_view_tablet,
                  slidesPerGroup: blok.slides_per_view_tablet,
                  spaceBetween: 24,
                },
              }}
            >
              {blok.days.length > 0 &&
                blok.days.map(
                  (content: { card: { _uid: string } }, id) =>
                    content.card.length > 0 && (
                      <SwiperSlide key={content.card[0]._uid}>
                        {React.createElement(
                          Components(content.card[0].component),
                          {
                            blok: content.card[0],
                            onClick: () => handleShowModal(id, !showModal),
                          }
                        )}
                      </SwiperSlide>
                    )
                )}
            </Swiper>
            {blok.days.length > 1 && (
              <>
                <StyledButton
                  onClick={() => swiperRefCard.current.swiper.slidePrev()}
                  disabled={currentCard === 0}
                >
                  <IconV2 icon="arrow-left" />
                </StyledButton>
                <StyledButton
                  onClick={() => swiperRefCard.current.swiper.slideNext()}
                  disabled={
                    swiperRefCard.current !== undefined &&
                    swiperRefCard.current.swiper.snapIndex + 1 ===
                      swiperRefCard.current.swiper.snapGrid.length
                  }
                >
                  <IconV2 icon="arrow-right" />
                </StyledButton>
              </>
            )}
          </StyledCarousel>
        </>
      )}
    </>
  )
}
